import {
    Component,
    OnInit,
    Input,
    ViewChild,
    Output,
    EventEmitter
} from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import { EntityCodes, MasterConstants } from "../../Models/EnumModels";
import {
    GuestLookup,
    Staff_Search_Assigment
} from "../../Models/ResponseModels";
import * as _ from "lodash";
import { UserService } from "../../Services/UserService";
import {
    NgbModal,
    NgbActiveModal,
    NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { AppSettings } from "../../Library/AppSettings";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { PMSService } from "../../Services/PMSService";
import { UploadImageRequest } from "../../Models/RequestModels";

@Component({
    selector: "UploadImage",
    templateUrl: "./UploadImage.html"
})
export class UploadImage extends BaseComponent implements OnInit {
    @ViewChild("content") content;
    ModalRef: NgbModalRef;
    Model: any;
    ImageObj: UploadImageRequest;
    _MasterConstants = MasterConstants;
    MaximumImageSize: any;

    //@Output() StaffImageUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        private userService: UserService,
        private modalService: NgbModal,
        private _sanitizer: DomSanitizer,
        private pmsService: PMSService
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {}

    Open(EntityId, EntityCode): void {
        this.ClearErrors();
        this.ImageObj = new UploadImageRequest();
        this.Model = {};
        this.Model.EntityId = EntityId;
        this.Model.EntityCode = EntityCode;
        this.MaximumImageSize = AppSettings.MaxImageSize_MB() + " MB";

        this.ModalRef = this.modalService.open(this.content, {
            centered: true,
            backdrop: "static"
        });
    }

    GetExtenstion(filename: string): string {
        return filename.split(".").pop();
    }

    onFileChanged(fileInput: any): void {
        this.ImageObj = new UploadImageRequest();

        if (fileInput.target.files && fileInput.target.files[0]) {
            let objThis = this;

            this.ClearErrors();
            let file = fileInput.target.files[0];
            if (!this.IsFilenameValid(file.name)) {
                return;
            }

            if (MasterConstants.IsImage(file.name) == false) {
                this.SetExtensionError(file.name);
            } else {
                let reader = new FileReader();

                reader.onload = function(e: any) {
                    objThis.ImageObj.Base64String = e.target.result;
                    objThis.ImageObj.FileName = file.name;
                    objThis.ImageObj.FileSize = file.size;
                };

                reader.readAsDataURL(file);
            }
        } else {
            this.ClearErrors();
        }
    }

    ValidateSize(): void {
        if (this.ImageObj.FileSize > AppSettings.MAX_IMAGE_SIZE) {
            let errorText = this.translate.instant("ERR.ERR_ATTACHMENT_SIZE");
            this.AddError(
                errorText + " " + AppSettings.MaxImageSize_MB() + " MB"
            );
        }
    }

    IsFilenameValid(name): boolean {
        const regex = new RegExp(/^([a-zA-Z0-9 _-]{1,}\.[a-zA-Z0-9]{1,10})$/);
        if (name.trim().length > 200) {
            let errorText = this.translate.instant("ERR.ERR_LONG_FILENAME");
            this.AddError(errorText);
            return false;
        }
        if (!regex.test(name.trim())) {
            let errorText = this.translate.instant("ERR.ERR_SPECIAL_CHAR_NOT_ALLOWED");
            this.AddError(errorText);
            return false;
        }
        return true;
    }

    SetExtensionError(fileName: any) {
        let strError = this.GetTranslation("ERR.ERR_ATTACH_FILE_TYPE_ALLOWED");
        strError = strError.replace("#filetype#", this.GetExtenstion(fileName));
        strError = strError.replace(
            "#acceptedformat#",
            MasterConstants.GetAcceptedImageExtensionsAsString()
        );

        this.AddError(strError);
    }

    onSubmit(): void {
        if (!this.ImageObj.FileName && this.HasErrors) return;

        this.ClearErrors();

        if (!this.ImageObj.FileName) {
            this.AddError("ERR.ERR_SELECT_IMAGE");
            return;
        }

        this.ValidateSize();

        if (this.HasErrors) {
            return;
        }

        this.ImageObj.EntityId = this.Model.EntityId;
        if (this.Model.EntityCode == EntityCodes.Staff) {
            this.userService.UploadImage(this.ImageObj).then(data => {
                this.FromBaseResponse(data);
                if (this.HasErrors) return;
                this.GetMultilingualToast(
                    "TS.TS_FILE_UPDATED_SUCCESS",
                    "success"
                );
                this.ModalRef.close();
            });
        }

        if (this.Model.EntityCode == EntityCodes.Guest) {
            this.pmsService.UploadImage(this.ImageObj).then(data => {
                this.FromBaseResponse(data);
                if (this.HasErrors) return;
                this.GetMultilingualToast(
                    "TS.TS_FILE_UPDATED_SUCCESS",
                    "success"
                );
                this.ModalRef.close();
            });
        }
    }
}
